import React, { useEffect, useState } from 'react';
import { Grid, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styles } from './styles';
import { useDisplayUserMutation } from '../../../api/users';
import UserData from '../UserData';
const ViewUsers = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const [userDetails, setUserDetails] = useState({});
    const { enqueueSnackbar } = useSnackbar();

    const [displayUser, { isLoading }] = useDisplayUserMutation();

    useEffect(() => {
        async function fetchData() {
            const bodyFormData = new FormData();
            if (params.companyId) {
                bodyFormData.append('company', params.companyId);
            }
            bodyFormData.append('id', params.id);
            try {
                const response = await displayUser(bodyFormData).unwrap();
                if (!response) return;
                if (response?.status === 'ERROR') throw new Error(response?.message);
                if (response?.employeeInstance) {
                    setUserDetails(response);
                }
            } catch (error) {
                if (error?.statusCode === 400) enqueueSnackbar(error?.data?.message, { variant: 'error' });
                else
                    enqueueSnackbar(error?.message || 'Something went wrong! User could not be fetched.', {
                        variant: 'error',
                    });
            }
        }
        fetchData();
    }, [params.id]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Users</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() =>
                                        navigate(params.companyId ? `/company/${params.companyId}/users` : '/users')
                                    }
                                >
                                    Back
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <UserData isLoading={isLoading} user={userDetails} id={params.id} />
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default ViewUsers;
